import { Autocomplete, TextField } from '@mui/material';
import {
  Control,
  Controller,
  UseFormGetValues,
  useWatch,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { EmpPosition } from '~/data/employee/types';
import { UnitPosition } from '~/data/unitPositions';
import { Form } from '~/features/RehireDialog/hooks/useRehireEmpForm';
import { useSxStyles } from '~/features/RehireDialog/useStyles';

type Props = {
  control: Control<Form>;
  getValues: UseFormGetValues<Form>;
  empData: EmpPosition;
  unitPositions: UnitPosition[];
};

export const UnitPositionComponent = ({
  control,
  getValues,
  empData,
  unitPositions,
}: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  const fInternalPositionUnitValue = useWatch({
    control,
    name: 'rehire.empPosition.fInternalPositionUnit',
  });

  const filteredUnitPositions = unitPositions.filter(
    (up) =>
      up.fUnitPositionUnitFk === fInternalPositionUnitValue ||
      (!fInternalPositionUnitValue &&
        up.fUnitPositionUnitFk === empData.fInternalPositionUnit),
  );

  return (
    <Controller
      control={control}
      name={'rehire.empPosition.fEmpUnitPositions'}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          disabled={fInternalPositionUnitValue === -1}
          sx={{ ...sxStyles.selectStyle, ...sxStyles.inputBottomMargin }}
          placeholder={' '}
          options={filteredUnitPositions}
          getOptionLabel={(c) =>
            `${c.fUnitPositionPosNumber}, ${c.fUnitPositionName}`
          }
          onChange={(e, value) => {
            onChange(value.map((up) => up.fUnitPositionId));
          }}
          value={
            filteredUnitPositions.filter((up) =>
              value.includes(`${up.fUnitPositionId}`),
            ) || []
          }
          renderInput={(params) => (
            <TextField {...params} label={t('fEmpUnitPositions')} />
          )}
          multiple
        />
      )}
    />
  );
};
